/*
 * @Author: wsx
 * @Date: 2022-01-19 09:28:58
 * @LastEditTime: 2022-01-19 17:49:18
 * @LastEditors: your name
 * @Description:
 */
import request from "@/utils/request.js";

// 添加用户
export const addUser = data => {
  return request({
    url: "/api/hz-smart-community/sys/user/save",
    data: data || {},
    method: "post"
  });
};

// 获取部门人员列表
export const queryUserList = data => {
  return request({
    url: "/api/hz-smart-community/sys/user/list",
    params: data || {}
  });
};

// 批量修改用户信息
export const batchUpdateUser = data => {
  return request({
    url: "/api/hz-smart-community/sys/user/updatelist",
    data: data || {},
    method: "POST"
  });
};

// 修改用户信息
export const updateUser = data => {
  return request({
    url: "/api/hz-smart-community/sys/user/update",
    data: data || {},
    method: "POST"
  });
};

// 修改用户信息
export const deleteUser = data => {
  return request({
    url: "/api/hz-smart-community/sys/user/delete",
    data: data || {},
    method: "POST"
  });
};

// 重置用户密码
export const resetPassword = data => {
  return request({
    url: "/api/hz-smart-community/sys/user/resetPassword",
    data: data || {},
    method: "POST"
  });
};

// 停用账号
export const stopUser = data => {
  return request({
    url: "/api/hz-smart-community/sys/user/stop",
    data: data || {},
    method: "POST"
  });
};
// 启用/禁用账号
export const saveStatus = data => {
  return request({
    url: "/api/hz-smart-community/sys/user/savestatus",
    data: data || {},
    method: "POST"
  });
};
// 重置用户密码
export const loglist = data => {
  return request({
    url: "/api/hz-smart-community/sys/log/list",
    params: data || {}
  });
};
// 修改用户密码
export const changePassword = data => {
  return request({
    url: "/api/hz-smart-community/sys/user/password",
    data: data || {},
    method: "POST"
  });
};